// ** React Imports
import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const UserList = lazy(() => import('../../views/apps/user/list'))
const Registro = lazy(() => import('../../views/registro'))
const ColaboradorList = lazy(() => import('../../views/apps/colaborador/list'))
const RangeList = lazy(() => import('../../views/apps/range/list'))

const AppRoutes = [
  {
    element: <UserList />,
    path: '/apps/user/list'
  },
  {
    element: <Registro />,
    path: '/apps/registro'
  },
  {
    element: <ColaboradorList />,
    path: '/apps/colaborador/list'
  },
  {
    element: <RangeList />,
    path: '/apps/range/list'
  }
]

export default AppRoutes
